import { render } from "./EmptyCartView.vue?vue&type=template&id=3e9bba04"
import script from "./EmptyCartView.vue?vue&type=script&lang=js"
export * from "./EmptyCartView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__